import axios from "axios"
import { config } from './apiUrl';

export  const getUnderLing = (period, ric) =>
    axios.get(`${config.getUnderlying}?period=${period}&ric=${ric}`)